import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
export const fetchServices = _ref => {
  let {
    httpClient: _httpClient,
    errorHandler
  } = _ref;
  return async _ref2 => {
    let {
      serviceIds
    } = _ref2;
    try {
      const response = await errorHandler.withErrorHandler(() => _httpClient.request(queryServices({
        query: serviceIds ? {
          filter: {
            id: {
              $in: serviceIds
            }
          }
        } : {}
      })), {
        errorCodesMap: {}
      });
      return response.data.services;
    } catch (e) {
      const resolvedError = errorHandler.getResolvedError(e);
      console.error(resolvedError);
      return undefined;
    }
  };
};
//# sourceMappingURL=fetch-services.js.map